<template>
  <div>
    <h1>QR CODE FOR RECEIPT</h1>
    <img v-if="token" :src="`https://qrcode.tec-it.com/API/QRCode?data=${token}`" alt="QR Code" width="200" height="200" />
  </div>

</template>

<script>

export default {
  name: 'OperatorQRcode',
  data() {
    return {
      token: null,
    }
  },
  mounted() {
    const user = this.$store.getters.user;
    if (user && ('id' in user) && user.id) {
      this.token = JSON.stringify({ token: btoa('operatorId_' + user.id) });
    }
  },
}
</script>
